import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Loader_Search_Fields: {[id:string]: ISearchProviderField} = {
    WB_LOADER_ID:           {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB Loader Id',          columnResourceName: 'colId',           alignment: HorizAlignment.Left},  domainOptions: {}},
    LOADER_ID:              {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Loader Id',             columnResourceName: 'colId',           alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    LOADER_NAME:            {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Loader Name',           columnResourceName: 'colLName',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    WB_BUSINESSUNIT_ID:     {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB BusinessUnit Id',    columnResourceName: 'colBUnitId',      alignment: HorizAlignment.Left},  domainOptions: {}},
    WB_LOADERSOURCE_ID:     {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB LoaderSource Id',    columnResourceName: 'colSrcId',        alignment: HorizAlignment.Left},  domainOptions: {}},
    SOURCE_FILTER:          {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Source Filter',         columnResourceName: 'colSrcFltr',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    LOADERTARGET_TYPE:      {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Loader Target Type',    columnResourceName: 'colTrgtType',     alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    LOADERTARGET_ID:        {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Loader Target ID',      columnResourceName: 'colTrgtId',       alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    WB_LOADERTARGET_ID:     {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB Loader Target ID',   columnResourceName: 'colTrgtId',       alignment: HorizAlignment.Left},  domainOptions: {}},
    WORKER_COUNT:           {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'Worker Count',          columnResourceName: 'colWrkerCnt',     alignment: HorizAlignment.Left},  domainOptions: {}},
    WB_JOB_ID_OVRD:         {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB Job ID Ovrd',        columnResourceName: 'colJobId',        alignment: HorizAlignment.Left},  domainOptions: {}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    DELETED_IND:            {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Deleted Ind',            columnResourceName: 'colDeletedInd',   alignment: HorizAlignment.Left},  domainOptions: {}},
    DELETED_DT:             {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Deleted Date',           columnResourceName: 'colDeleted_Date', alignment: HorizAlignment.Left},  domainOptions: {}},
    MDSET_NAME:            {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Master Data Set Name',           columnResourceName: 'colLName',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    COMPANY_NAME:          {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Company Name',           columnResourceName: 'colLName',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
};

const LoaderSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_LOADER_ID',
        id_ui: 'LOADER_ID',
        name: 'LOADER_NAME'

    },

    searchProviderFields: vUI_Loader_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Loader_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res:any)=>{
                    resolve(res)
                })
                .catch((err)=>{
                    error(err)
                })
        })
    }
};

const LoaderSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "LoaderSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'LOADER_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'LOADER_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'LOADER_ID', 'LOADER_NAME', 'MDSET_NAME', 'COMPANY_NAME','CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: LoaderSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const LoaderSearch: ISearch = {
    searchName: "Find Loader",
    renderOptions: {ui5ResourceId: "LoaderSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [LoaderSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("LoaderBO", "Loader", LoaderSearch, "Loader Search")

export {LoaderSearch}